/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Compax Frontend API-v2
 * API by Compax
 * OpenAPI spec version: 157.0.0-SNAPSHOT
 */

export type CampaignPeriodCampaignPeriodEnum =
  (typeof CampaignPeriodCampaignPeriodEnum)[keyof typeof CampaignPeriodCampaignPeriodEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampaignPeriodCampaignPeriodEnum = {
  until_cancel: "until_cancel",
  one_time: "one_time",
  date_specific: "date_specific",
} as const;
